module.exports = __webpack_public_path__ + "img/open_in_browser.df6ceb17.svg";